import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    clear: (event: any) => void;
    itemCount: number;
    search: string;
};

export const SearchStatus = ({ clear, itemCount = 0, search = '' }: Props) => {
    if (!search) {
        return null;
    }

    return (
        <section className="block w-full pb-xs">
            <div className="flex items-center gap-xs">
                <BodyPrimary className="uppercase">
                    <FormattedMessage
                        id="results_for"
                        values={{ count: `${itemCount}` }}
                    />
                </BodyPrimary>
                <BodyPrimary className="m-0 hui-text-h3">{` ${search}`}</BodyPrimary>
                <div
                    className="cursor-pointer underline"
                    onClick={clear}
                >
                    <BodyPrimary color="info">
                        <FormattedMessage id="clear" />
                    </BodyPrimary>
                </div>
            </div>
            {!itemCount && (
                <div className="my-md border border-border-success p-[134px] text-center xsMax:p-xl">
                    <BodyPrimary color="secondary">
                        <FormattedMessage id="try_another_search" />
                    </BodyPrimary>
                </div>
            )}
        </section>
    );
};
